<template>
  <div class="customer">
    <div class="container">
      <h2>服务客户</h2>
      <h3>Customer</h3>
      <div style="margin: 60px auto 0 auto;position: relative;width: 94%;">
        <swiper class="myCus" :options="cusOptions">
          <swiper-slide v-for="(i,item) in logoList" :key="item" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5" data-wow-offset="20">
            <img :src="i.url" alt="">
          </swiper-slide>
        </swiper>
				<div class="swiper-button-prev" slot="button-prev"></div>
				<div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customer',
  data() {
    return{
      logoList: [
				{url:require('../../assets/logo01.png')},
				{url:require('../../assets/logo02.png')},
				{url:require('../../assets/logo03.png')},
				{url:require('../../assets/logo04.png')},
				{url:require('../../assets/logo05.png')},
				{url:require('../../assets/logo06.png')},
				{url:require('../../assets/logo07.png')},
				{url:require('../../assets/logo08.jpg')},
				{url:require('../../assets/logo09.png')},
				{url:require('../../assets/logo10.png')},
				{url:require('../../assets/logo11.png')},
				{url:require('../../assets/logo12.png')},
				{url:require('../../assets/logo13.png')},
				{url:require('../../assets/logo14.png')},
				{url:require('../../assets/logo15.png')},
				{url:require('../../assets/logo16.jpg')},
				{url:require('../../assets/logo17.jpg')},
				{url:require('../../assets/logo18.jpg')},
				{url:require('../../assets/logo19.jpg')},
				{url:require('../../assets/logo20.png')},
				{url:require('../../assets/logo21.jpg')},
				{url:require('../../assets/logo22.jpg')},
				{url:require('../../assets/logo23.jpg')},
				{url:require('../../assets/logo24.jpg')},
				{url:require('../../assets/logo25.jpg')},
				{url:require('../../assets/logo26.png')},
				{url:require('../../assets/logo27.jpg')},
				{url:require('../../assets/logo28.jpg')},
				{url:require('../../assets/logo29.jpg')},
				{url:require('../../assets/logo30.png')},
				{url:require('../../assets/logo31.jpg')},
				{url:require('../../assets/logo32.png')},
			],
      cusOptions:{
				autoplay:{
					delay: 3000,
				},
        slidesPerView: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl:'.swiper-button-prev',
        },
				loop: true,
				breakpoints: {
					640: {
						slidesPerView: 2,
						spaceBetween: 10,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 10,
					}

				}
      }
    };
  },
	mounted(){
  		var options={ live:false};
    	var wow=new this.$wow.WOW(options).init();
	}
}
</script>

<style>
.customer{
  background: #fff;
  padding: 50px 0;
}
.customer .swiper-slide{
	overflow: hidden;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #d4d4d4;
	background: #fff;
	height: 200px;
	box-sizing: border-box;
	text-align: center;
	display: flex;
	justify-content: center;
	flex-direction: column;
}
.customer .swiper-button-prev,.customer .swiper-button-next{
  --swiper-navigation-size: 25px;
  color: #fff;
  background: rgba(0,0,0,.6);
  z-index: 2;
	width: 56px;
	height: 56px;
	padding: 0;
	margin-top: -28px;
}
.customer .swiper-button-prev{
  left: -37px;
}
.customer .swiper-button-next{
  right: -37px;
}
.customer .swiper-button-prev::after,.customer .swiper-button-next::after{
	font-family: element-icons!important;
	font-size: 20px;
	transition: all .3s ease;
}
.customer .swiper-button-prev::after{
	content: '\E792';
}
.customer .swiper-button-next::after{
	content: '\E791';
}
.customer .swiper-button-prev::before,.customer .swiper-button-next::before{
	font-family: element-icons!important;
	content: '\E6D8';
	font-size: 20px;
	position: absolute;
	top: 47%;
	transform: translate(-50%,-50%);
	opacity: 0;
	width: 0;
	overflow: hidden;
	transition: all .3s ease;
}
.customer .swiper-button-prev::before{
	left: 70%;
}
.customer .swiper-button-next::before{
	left: 30%;
}
.customer .swiper-button-prev:hover::after{
	transform: translateX(-40%);
}
.customer .swiper-button-next:hover::after{
	transform: translateX(40%);
}
.customer .swiper-button-prev:hover::before,.customer .swiper-button-next:hover::before{
	width: 20px;
	left: 50%;
	opacity: 1;
}
@media (max-width: 992px){
  .customer h2{
    font-size: 18px;
  }
	.customer .container>div{
		width: 80% !important;
	}
	.customer .swiper-slide{
		height: 100px;
	}
	.customer .swiper-button-prev,.customer .swiper-button-next{
		width: 30px;
		height: 30px;
		margin-top: -16px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/index/customer.vue